import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description?: string;
  canonical?: string;
}

export function SEOMeta({
  title,
  description,
  canonical,
}: SEOMetaProps) {
  useEffect(() => {
    document.title = `${title} | Logicraft Infotech`;

    // Meta Description
    if (description) {
      let metaDesc = document.querySelector(
        'meta[name="description"]'
      ) as HTMLMetaElement | null;

      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }

      metaDesc.content = description;
    }

    // Canonical URL
    if (canonical) {
      let canonicalTag = document.querySelector(
        'link[rel="canonical"]'
      ) as HTMLLinkElement | null;

      if (!canonicalTag) {
        canonicalTag = document.createElement('link');
        canonicalTag.rel = 'canonical';
        document.head.appendChild(canonicalTag);
      }

      canonicalTag.href = canonical;
    }
  }, [title, description, canonical]);

  return null;
}